export enum HealthCheckType {
  SUCCESS = 'success',
  ERROR = 'error',
}
